import gql from 'graphql-tag'
import { EventPaginator } from 'src/types/fam-graphql'

import { queryServiceCreator } from '../../../../helpers/GraphqlHelpers'
import { EventListFragment } from '../../../fragments/EventListFragment'

const query = gql`
  query events(
    $first: Int!
    $page: Int!
    $types: [ID!]
    $departments: [ID!]
    $places: [Place!]
    # $durations: [EventDuration!]
    $modes: [ID!]
    # $targets: [ID!]
    $weeks: [EventWeek!]
    $query: String
    $paid: Boolean
  ) {
    events(
      first: $first
      page: $page
      types: $types
      departments: $departments
      places: $places
      # durations: $durations
      modes: $modes
      # targets: $targets
      weeks: $weeks
      query: $query
      paid: $paid
    ) {
      data {
        ...EventListFragment
      }
      paginatorInfo {
        count
        currentPage
        firstItem
        hasMorePages
        lastItem
        lastPage
        perPage
        total
      }
    }
  }
  ${EventListFragment}
`

const transformer = ({ events }: { events: EventPaginator }): any => events

type variables = {
  first?: number
  page?: number
}

export default queryServiceCreator<variables>(query, transformer)
